export const testimonials = [
  {
    id: 1,
    name: 'Amanda Foster',
    title: 'IT Director',
    company: 'Pacific West Healthcare',
    rating: 5,
    location: 'Los Angeles, CA',
    date: '2025-11-12',
    text: 'Greenly handled our hospital\'s decommissioned server farm with absolute professionalism. The HIPAA-compliant data destruction certificates were delivered same day. We won\'t use anyone else.',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20female%20IT%20director%20headshot%2C%20mid%2040s%2C%20confident%20smile%2C%20corporate%20office%20background%2C%20high%20quality%20portrait%20photography&width=120&height=120&seq=tst001&orientation=squarish',
  },
  {
    id: 2,
    name: 'Marcus Johnson',
    title: 'Operations Manager',
    company: 'Johnson Financial Group',
    rating: 5,
    location: 'Burbank, CA',
    date: '2025-10-28',
    text: 'We had 400 old computers from our office move. Greenly picked everything up, destroyed all drives on-site, and had our certificates ready within 2 hours. Incredible service.',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20African%20American%20male%20operations%20manager%20headshot%2C%20business%20attire%2C%20warm%20confident%20smile%2C%20clean%20office%20background%2C%20professional%20portrait&width=120&height=120&seq=tst002&orientation=squarish',
  },
  {
    id: 3,
    name: 'Linda Chen',
    title: 'Compliance Officer',
    company: 'SoCal Credit Union',
    rating: 5,
    location: 'Glendale, CA',
    date: '2025-12-03',
    text: 'Our auditors were impressed with the level of documentation Greenly provided. Every serial number, every destruction timestamp — it\'s exactly what GLBA compliance requires. Highly recommend.',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20female%20compliance%20officer%20headshot%2C%20business%20professional%2C%20approachable%20smile%2C%20modern%20office%20background%2C%20corporate%20portrait%20photography&width=120&height=120&seq=tst003&orientation=squarish',
  },
  {
    id: 4,
    name: 'Roberto Sanchez',
    title: 'Office Manager',
    company: 'Sanchez Architecture',
    rating: 5,
    location: 'Pasadena, CA',
    date: '2025-09-15',
    text: 'Dropped off a van full of old computers and monitors — no appointment, no hassle. The team was friendly, fast, and we felt great knowing it was all handled responsibly. Five stars.',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Latino%20male%20office%20manager%20headshot%2C%20casual%20business%20attire%2C%20relaxed%20friendly%20smile%2C%20architectural%20office%20setting%2C%20professional%20photo&width=120&height=120&seq=tst004&orientation=squarish',
  },
  {
    id: 5,
    name: 'Stephanie Park',
    title: 'Sustainability Director',
    company: 'EcoTech Innovations',
    rating: 5,
    location: 'Santa Monica, CA',
    date: '2025-08-22',
    text: 'As a sustainability-focused company, we needed a recycling partner who shared our values. Greenly\'s R2 certification and zero-landfill commitment sealed the deal. Our employees love the partnership.',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Korean%20American%20female%20sustainability%20director%20headshot%2C%20eco%20conscious%20professional%2C%20bright%20smile%2C%20green%20office%20environment%2C%20corporate%20headshot&width=120&height=120&seq=tst005&orientation=squarish',
  },
  {
    id: 6,
    name: 'David Okafor',
    title: 'Facilities Director',
    company: 'Westside Unified School District',
    rating: 5,
    location: 'Culver City, CA',
    date: '2026-01-08',
    text: 'We cleared out 12 classrooms of old Chromebooks and desktops. Greenly sent a truck, loaded everything, and gave us a full recycling certificate for our district records. Seamless from start to finish.',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Nigerian%20American%20male%20facilities%20director%20headshot%2C%20mid%2050s%2C%20warm%20authoritative%20smile%2C%20school%20administration%20office%20background%2C%20professional%20portrait&width=120&height=120&seq=tst006&orientation=squarish',
  },
];

export const aggregateRating = {
  ratingValue: 4.9,
  reviewCount: 312,
  bestRating: 5,
  worstRating: 1,
};
